import type { TableSearchParameters } from '@/ui/Table/tableProperties';
import type { ColumnsAvailableProps } from '@/ui/Table/useColumnsFilter';
import useColumnsFilter from '@/ui/Table/useColumnsFilter';
import TableColumnStorage from '@/util/localStorage/TableColumnStorage';
import type { FileFragmentFragment } from '@/graphql/generated/graphql';
import { protolusColumnsAvailable, protolusColumnsOrder } from '~/ui/Table/protulus/protolusColumns';

type Columns = keyof FileFragmentFragment | 'download';

const columnsOrder: Columns[] = [
  'id',
  'uri',
  'name',
  'original_name',
  'mime_type',
  'ext',
  'path',
  'size',
  'download',
  ...protolusColumnsOrder,
];

const storage = new TableColumnStorage<Columns[]>('files', [
  'id',
  'uri',
  'name',
  'original_name',
  'mime_type',
  'ext',
  'path',
  'size',
  'download',
]);

const columnsAvailables: ColumnsAvailableProps<Columns> = {
  id: {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 10,
    sorter: true,
  },
  uri: {
    title: 'URI',
    dataIndex: 'uri',
    key: 'uri',
    sorter: true,
  },
  name: {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    sorter: true,
  },
  original_name: {
    title: 'Original Name',
    dataIndex: 'original_name',
    key: 'original_name',
    sorter: true,
  },
  mime_type: {
    title: 'Mime Type',
    dataIndex: 'mime_type',
    key: 'mime_type',
    sorter: true,
  },
  ext: {
    title: 'Ext',
    dataIndex: 'ext',
    key: 'ext',
    sorter: true,
  },
  path: {
    title: 'Path',
    dataIndex: 'path',
    key: 'path',
    sorter: true,
  },
  size: {
    title: 'Size',
    dataIndex: 'size',
    key: 'size',
    sorter: true,
  },
  download: {
    title: 'Download',
    dataIndex: 'download',
    key: 'download',
    sorter: true,
  },
  ...protolusColumnsAvailable,
};

interface FilesColumnsArgs {
  orderBy: TableSearchParameters['orderBy'];
}

const useFilesColumns = ({ orderBy }: FilesColumnsArgs) => {
  const columns = useColumnsFilter({
    orderBy,
    storage,
    columnsOrder,
    columnsAvailables,
  });

  return columns;
};

export default useFilesColumns;
